const FETCH_PAYMENT_COIN_ITEMS = 'store/FETCH_PAYMENT_COIN_ITEMS';

const FETCH_PAYMENT_BALLOON_ITEMS = 'store/FETCH_PAYMENT_BALLOON_ITEMS';

const VERIFY_PAYMENT = 'store/VERIFY_PAYMENT';

const USE_IN_APP_PURCHASE = 'store/USE_IN_APP_PURCHASE';

const FETCH_PURCHASE_INFO = 'store/FETCH_PURCHASE_INFO';

const RESET_PURCHASE_INFO = 'store/RESET_PURCHASE_INFO';

const RESET = 'store/RESET';


export default {
  FETCH_PAYMENT_COIN_ITEMS,
  FETCH_PAYMENT_BALLOON_ITEMS,
  VERIFY_PAYMENT,
  USE_IN_APP_PURCHASE,
  FETCH_PURCHASE_INFO,
  RESET_PURCHASE_INFO,
  RESET,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/store/types.js